// extracted by mini-css-extract-plugin
module.exports = {"terms":"TradingConditions_terms__eLPMj","trading_times":"TradingConditions_trading_times__GJBQB"};